import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import { ILink } from 'tbk-components/src/components/Button';
import { IImage } from 'tbk-components/src/components/Image';
import Video, { IVideoProps, IVideo } from 'tbk-components/src/components/Video';
import TbkHeroBanner from './ContentHeroBanner';
import Tags from '../Tags';

export interface IHeroBannerProps extends IBaseElementProps {
	heading?: string;
	subheading?: string;
	link?: ILink;
	backgroundImage?: IImage;
	contentBackgroundStyle?:
		| 'default'
		| 'light'
		| 'black'
		| 'grey'
		| 'light-grey'
		| 'yellow'
		| 'rollup-green'
		| 'worth-green'
		| 'blue'
		| 'light-blue'
		| 'orange'
		| 'overlay'
		| 'floating'
	contentPosition?: 'left' | 'right';
	buttonStyle?: 'default' | 'rounded';
	image?: IImage;
	video?: IVideoProps;
	tags?: ILink[];
}

/**
 * Hero Banner
 * @block
 * @requiresHooks
 * @icon format-image
 */

const HeroBanner: React.FC<IHeroBannerProps> = ({
	subheading,
	backgroundImage,
	image,
	video,
	contentBackgroundStyle = 'default',
	contentPosition = 'left',
	buttonStyle = 'default',
	children,
	tags = [],
	link,
	...props
}) => {
	const content = Array.isArray(tags) ? (
		<>
			{children}
			{tags && (
				<Tags tags={tags} />
			)}
		</>
	) : (
		children
	);

	return (
		<TbkHeroBanner
			{...props}
			link={link && link.label ? link : undefined}
			backgroundImage={backgroundImage}
			image={image}
			video={video}
			className={cn(
				'hero-banner',
				`hero-banner--content-${contentBackgroundStyle}`,
				`hero-banner--content-${contentPosition}`,
				`hero-banner--button-${buttonStyle}`,
				backgroundImage && 'hero-banner--bg-image',
				(!video?.poster && image) && 'hero-banner--image',
				video?.poster && 'hero-banner--video',
			)}
			children={content}
		/>
	);
};

export default HeroBanner;


